import React, { useContext, useEffect, useState } from "react";
import {
  fetchComplaintDetailsBs6PVIN,
  fetchComplaintDetailsNonBs6PVIN,
  fetchComplaintDetailspopup, // popup API
} from "./PvinKip";
import { FilterContext } from "../../context/Filter";

const CustomerComplaints = ({ data = [] }) => {
  const { arn: parArn, childArn } = useContext(FilterContext);

  const [customerComplaintFilter, setcustomerComplaintFilter] = useState("All");
  const [customerComplaintDataBs6, setCustomerComplaintDataBs6] = useState([]);
  const [customerComplaintDataNonBs6, setCustomerComplaintDataNonBs6] =
    useState([]);
  const [customerComplaintDatapopup, setCustomerComplaintDatapopup] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedComplaintType, setSelectedComplaintType] = useState("");

  // --- BS6 Complaints ---
  const fetchCustomerComplaintsBs6Data = async () => {
    try {
      const response = await fetchComplaintDetailsBs6PVIN(parArn, childArn);
      setCustomerComplaintDataBs6(response || []);
    } catch (error) {
      console.error("Error fetching BS6 complaints:", error);
    }
  };

  // --- Non BS6 Complaints ---
  const fetchComplaintDetailsNonBs6Data = async () => {
    try {
      const response = await fetchComplaintDetailsNonBs6PVIN(parArn, childArn);
      setCustomerComplaintDataNonBs6(response || []);
    } catch (error) {
      console.error("Error fetching Non-BS6 complaints:", error);
    }
  };

  // --- Popup API call when user clicks ---
  const handlePopupClick = async (row) => {
    const payload = {
      dataName: "parent",
      dataParent: parArn,
      dataProblemArea: row.Complaint_Type || "—",
      serviceType: "customerComplaintFilter",
    };

    try {
      const response = await fetchComplaintDetailspopup(payload);

      // Handle both possible response shapes
      const popupData = response?.data || response || [];

      // console.log("📥 Popup data received:", popupData);

      setCustomerComplaintDatapopup(popupData);
      setSelectedComplaintType(row.Complaint_Type);
      setShowPopup(true);
    } catch (error) {
      console.error("Error fetching popup complaints:", error);
    }
  };

  // --- Fetch initial data ---
  useEffect(() => {
    fetchCustomerComplaintsBs6Data();
    fetchComplaintDetailsNonBs6Data();
  }, []);

  // --- Filter selection ---
  const selectedData =
    customerComplaintFilter === "BS6"
      ? customerComplaintDataBs6
      : customerComplaintFilter === "Non BS-6"
        ? customerComplaintDataNonBs6
        : data;

  // --- Close popup when clicking outside modal ---
  const handleOutsideClick = (e) => {
    if (e.target.id === "popupOverlay") {
      setShowPopup(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 h-96 flex flex-col relative">
      {/* Header with Dropdown */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Customer Complaints</h2>
        <select
          value={customerComplaintFilter}
          onChange={(e) => setcustomerComplaintFilter(e.target.value)}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option>All</option>
          <option>BS6</option>
          <option>Non BS-6</option>
        </select>
      </div>

      {/* Scrollable Main Table */}
      <div className="overflow-y-auto overflow-x-auto flex-1 border border-gray-200 rounded-lg">
        <table className="w-full">
          <thead className="bg-[#1467B3] text-white sticky top-0 z-10">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">
                Primary Complaint Area
              </th>
              <th className="px-4 py-3 text-left font-semibold">
                Total Complaints
              </th>
              <th className="px-4 py-3 text-left font-semibold">
                Open Complaints
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedData && selectedData.length > 0 ? (
              selectedData.map((row, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                >
                  <td className="px-4 py-3 text-gray-700">
                    {row.Complaint_Type || "—"}
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold">
                    {row.Total_complaint ?? 0}
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                    <button
                      className="text-blue-600 underline hover:text-blue-800"
                      onClick={() => handlePopupClick(row)}
                    >
                      {row.Open_Complaint ?? 0}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="px-4 py-3 text-center text-gray-500">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div
          id="popupOverlay"
          onClick={handleOutsideClick}
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
        >
          <div className="bg-white rounded-lg shadow-xl w-11/12 md:w-3/4 lg:w-1/2 max-h-[80vh] overflow-y-auto p-6 relative">
            {/* Close button */}
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-red-600 text-2xl"
              onClick={() => setShowPopup(false)}
            >
              &times;
            </button>

            <h3 className="text-lg font-semibold mb-4 text-gray-800">
              Complaint Details —{" "}
              <span className="text-blue-600">{selectedComplaintType}</span>
            </h3>

            {customerComplaintDatapopup && customerComplaintDatapopup.length > 0 ? (
              <table className="w-full border border-gray-200">
                <thead className="bg-gray-100 text-gray-800">
                  <tr>
                    <th className="px-3 py-2 border">Complaint No</th>
                    <th className="px-3 py-2 border">Chassis No</th>
                    <th className="px-3 py-2 border">Reg. No</th>
                    <th className="px-3 py-2 border">Complaint Date</th>
                    <th className="px-3 py-2 border">Status</th>
                    <th className="px-3 py-2 border">Problem Area</th>
                  </tr>
                </thead>
                <tbody>
                  {customerComplaintDatapopup.map((item, idx) => (
                    <tr
                      key={idx}
                      className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-3 py-2 border">{item.COMPLAINT_NO}</td>
                      <td className="px-3 py-2 border">{item.CHASSIS_NO}</td>
                      <td className="px-3 py-2 border">
                        {item.VEHICLE_REGISTRATION_NUMBER}
                      </td>
                      <td className="px-3 py-2 border">{item.COMPLAINT_DATE_TIME}</td>
                      <td className="px-3 py-2 border">{item.COMPLAINT_STATUS}</td>
                      <td className="px-3 py-2 border">{item.PROBLEM_AREA}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-center text-gray-500">
                No complaint details found.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerComplaints;
